import React from 'react'
import _ from 'lodash'
import { hydrate } from 'react-dom'
import { Provider } from 'react-redux'
import { BrowserRouter as Router } from 'react-router-dom'
import { initSentryPlugin } from 'src/common/razzle-platform-components/monitoring/sentry/client'
import App from 'src/App'
import { configureStore } from 'src/redux'
import { TranslatitonProvider } from 'src/common/razzle-platform-translate/TranslationProvider'
import { MobileDetectorProvider } from 'src/common/razzle-platform-components/hooks/mobile-detector'
// we need import storage when use getObjectItem, setObjectItem custom properties of localStorage
import 'src/common/razzle-platform-components/utils/storage'

// we initialize sentry plugin here for tracking the bug of client side
initSentryPlugin()

declare global {
	interface Window {
		__PRELOADED_STATE__: any
	}
}

const preloadState: any = window.__PRELOADED_STATE__
// in client side we get the user form loacal storage and set it in its reudcer because in server side we can't access to locale storage
// todo: getObjectItem is temporary solution waiting the new platform of react
const user = localStorage.getObjectItem('user')
const authenticationToken = localStorage.getItem('authentication_token')

if (user && authenticationToken) {
	preloadState.userModel.user = {
		...user,
		roles: user.roles.map(role => role.name)
	}
}

const store = configureStore(preloadState)


hydrate(
	<Provider store={store}>
		<MobileDetectorProvider userAgent={window.navigator.userAgent} >
			<TranslatitonProvider>
				<Router>
					<App />
				</Router>
			</TranslatitonProvider>
		</MobileDetectorProvider>
	</Provider>,
	document.getElementById('root')
)

if (module.hot) {
	module.hot.accept('src/App', () => {
		hydrate(
			<Provider store={store}>
				<MobileDetectorProvider userAgent={window.navigator.userAgent} >
					<TranslatitonProvider>
						<Router>
							<App />
						</Router>
					</TranslatitonProvider>
				</MobileDetectorProvider>
			</Provider>,
			document.getElementById('root')
		)
	})
}
